<ul class="bl-display--flex bl-flex-flow--wrap">
  <ng-container
    *ngFor="let item of field.enum | slice : 0 : (allProductsVisible ? undefined : maxInitialProducts); let i = index; let even = even"
  >
    <li class="selection-grid-container bl-margin-bottom--16" [class.bl-margin-left--0]="even">
      <button
        [attr.data-automation-id]="field.automationId + '-' + i"
        [id]="'arcdx-product-' + i"
        type="button"
        (click)="selectItemValue(item.value)"
        class="selection-button bl-display--flex bl-align-items--center"
        [class.selected]="field.data.value === item.value"
      >
        <!-- questions on this? see comments in dx-product-image component -->
        <!-- TODO: The below data attribute does not seem to exist. Please revisit. -->
        <dx-product-image size="56px" [product]="item['data'].icon" flowType="oao" class="bl-display--flex"></dx-product-image>
        <span class="bl-display--block bl-margin-left--16 bl-font-weight--800 bl-font-color--black bl-text-align--left">
          {{ item.label }}
          <span *ngIf="field.data.value === item.value" class="bl-screen-reader-only"> Selected </span>
        </span>
      </button>
    </li>
  </ng-container>
</ul>
<button
  *ngIf="field.enum.length > maxInitialProducts"
  (click)="allProductsVisible = !allProductsVisible"
  class="bl-font-color--primary bl-font-weight--800 bl-display--block bl-padding-y--16 bl-margin-x--auto"
>
  {{ toggleAllProductsText }}
</button>
